import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import {
  apiPut,
  getApiUrl,
  putMerchantsPublicIDFacilitiesFacilityPublicIDLogoPath,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
  facilityPublicID: string;
  file: File;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useUploadFacilityLogoMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      async ({ merchantPublicID, facilityPublicID, file }: Parameters) => {
        const path = putMerchantsPublicIDFacilitiesFacilityPublicIDLogoPath(
          merchantPublicID,
          facilityPublicID,
        );
        const form = new FormData();
        form.append("file", file);

        return apiPut(`${getApiUrl()}${path}`, form, {});
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: merchantKeys.all,
      });
      onSuccess?.();
    },
    onError,
  });
};
